// Reaction icons (SVG via lucide), replacing the ASCII glyphs (D03).
import { HandHeart, Lightbulb, PartyPopper, CircleHelp, ThumbsUp, type LucideIcon } from 'lucide-react';
import type { ReactionKind } from '@flory/shared';

export const REACTION_META: Record<ReactionKind, { label: string; icon: LucideIcon }> = {
  like: { label: 'Like', icon: ThumbsUp },
  celebrate: { label: 'Celebrate', icon: PartyPopper },
  insightful: { label: 'Insightful', icon: Lightbulb },
  support: { label: 'Support', icon: HandHeart },
  curious: { label: 'Curious', icon: CircleHelp },
};

export function ReactionIcon({ kind, size = 18 }: { kind: ReactionKind; size?: number }) {
  const I = REACTION_META[kind].icon;
  return <I size={size} strokeWidth={1.75} aria-hidden="true" focusable="false" />;
}
